import { Col, Row, Tabs } from "antd";
import { Icons } from "../assets/icons";
import CompanyForm from "../components/CompanyAccountSections/CompanyForm";
import PageHeader from "../components/ui/PageHeader";
import { ICON_SIZE } from "../repository/data.default";
import UserProfilePage from "./UserProfilePage";

// PD-02 §6.3 — two Account views on the same page: Company Account (profile
// of the company as a whole) and Personal Account (the signed-in user's own
// profile + preferences + password). Personal is the embedded UserProfilePage
// so the two surfaces stay in sync without a second route.
function CompanyAccountPage() {
  return (
    <Col className="flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <PageHeader
        title="ACCOUNT"
        icon={<Icons.CompanyAccountIcon width={ICON_SIZE} height={ICON_SIZE} />}
      />
      <Col className="flex flex-1 flex-col px-6">
        <Tabs
          defaultActiveKey="company"
          size="large"
          items={[
            {
              key: "company",
              label: "Company Account",
              children: (
                <Row className="flex flex-1">
                  <Col className="flex flex-1">
                    <CompanyForm />
                  </Col>
                </Row>
              ),
            },
            {
              key: "personal",
              label: "Personal Account",
              children: <UserProfilePage />,
            },
          ]}
        />
      </Col>
    </Col>
  );
}

export default CompanyAccountPage;
